import { Link, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ReturnLoginLink  : FC = () => {
  const { t } = useTranslation();

  return (
    <Text
      size="poppins16"
      variant="primary-black-text"
      textAlign="center"
      lineHeight="22px"
      mb="24px"
    >
      {t(' Already have an account? ')}
      <Link
        href='/auth/log-in'
        rel='noreferrer'
        variant="resetPassword"
        _hover={{ textDecoration: 'none' }}
      >
        {t('Log In')}
      </Link>
    </Text>
  );
};
